import React from "react";

interface PalettePanelProps {
    title: string;
    isOpen: boolean;
    children: React.ReactNode;
}

const PalettePanel: React.FC<PalettePanelProps> = ({
    title,
    isOpen,
    children,
}) => {
    const panelMaxWidth = "110vw";

    return (
        <div className="h-full w-full min-w-0 flex flex-col">
            <div
                className={[
                    "bg-white border-y border-slate-200 flex flex-col h-full min-h-0 overflow-hidden",
                    "transition-[max-width] duration-200 ease-out",
                ].join(" ")}
                style={{maxWidth: isOpen ? panelMaxWidth : "0px"}}
                aria-hidden={!isOpen}
            >
                {/* Title */}
                <div
                    className={[
                        "transition-[height,opacity] duration-200 overflow-hidden flex items-center shrink-0",
                        isOpen ? "h-9 opacity-100 px-3" : "h-0 opacity-0 px-3",
                    ].join(" ")}
                >
                    <span className="text-[12px] font-medium text-slate-800/90 truncate">
                        {title}
                    </span>
                </div>

                {/* Body — flex-1 fills remaining space after title */}
                <div
                    className={[
                        "flex-1 min-h-0 w-full overflow-hidden min-w-0",
                        "transition-[opacity,padding] duration-200 ease-out",
                        isOpen ? "px-3 pt-1 pb-3 opacity-100" : "p-0 opacity-0",
                    ].join(" ")}
                >
                    <div className="w-full h-full overflow-y-auto" style={{visibility: isOpen ? 'visible' : 'hidden'}}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PalettePanel;
